import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { ServiceRequestOptions } from '@dealstack/frontend/shared/other/react/ApiWrapper/types.ts';
import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer.ts';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common.ts';
import {
	MipKycSettingResponseDto,
	KycWorkflowSettingResponseDto,
	UpdateKycWorkflowSettingDto,
	UpdateMipKycSettingDto,
} from '@dealstack/shared/lib/generated';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn';

export const getMipKycSetting = async (options?: ServiceRequestOptions) => {
	return await makeRequest<{ payload: MipKycSettingResponseDto }>(
		{
			endpoint: API_PATHS.KYC_SETTING_MIP_GET,
			method: HTTP_METHOD.GET,
		},
		{
			...options,
		}
	);
};

export const getKycWorkflowKycSetting = async (
	kycWorkflowId: string,
	options?: ServiceRequestOptions
) => {
	return await makeRequest<{ payload: KycWorkflowSettingResponseDto }>(
		{
			endpoint: formatUnicorn(API_PATHS.KYC_SETTING_KYCWORKFLOW_KYCWORKFLOWID_GET, {
				kycWorkflowId,
			}),
			method: HTTP_METHOD.GET,
		},
		{
			...options,
		}
	);
};

export const updateMipKycSetting = async (
	data: UpdateMipKycSettingDto,
	options?: ServiceRequestOptions
) => {
	return await makeRequest<{ payload: MipKycSettingResponseDto }>(
		{
			endpoint: API_PATHS.KYC_SETTING_MIP_PUT,
			method: HTTP_METHOD.PUT,
			body: JSON.stringify(data),
		},
		{
			...options,
		}
	);
};

export const updateKycWorkflowKycSetting = async (
	kycWorkflowId: string,
	data: UpdateKycWorkflowSettingDto,
	options?: ServiceRequestOptions
) => {
	return await makeRequest<{ payload: KycWorkflowSettingResponseDto }>(
		{
			endpoint: formatUnicorn(API_PATHS.KYC_SETTING_KYCWORKFLOW_KYCWORKFLOWID_PUT, {
				kycWorkflowId,
			}),
			method: HTTP_METHOD.PUT,
			body: JSON.stringify(data),
		},
		{
			...options,
		}
	);
};
